export default __webpack_public_path__ + "4c4bf3405b77bbc7ac97ce4922ddf237.png";